import ErrorPage from './ErrorPage'

export default ErrorPage
// eslint-disable-next-line import/export
export * from './ErrorPage'
